export const LISTS_UPDATE_WISHLIST = 'LISTS_UPDATE_WISHLIST';
export const LISTS_ADD_PRODUCT_TO_LIST = 'LISTS_ADD_PRODUCT_TO_LIST';
export const LISTS_REMOVE_PRODUCT_FROM_LIST = 'LISTS_REMOVE_PRODUCT_FROM_LIST';
